import { render } from "./InputSimpleNumber.vue?vue&type=template&id=afa5063e"
import script from "./InputSimpleNumber.vue?vue&type=script&lang=js"
export * from "./InputSimpleNumber.vue?vue&type=script&lang=js"

import "./InputSimpleNumber.vue?vue&type=style&index=0&id=afa5063e&lang=css"

import exportComponent from "D:\\perso\\miam\\miam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__